"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Activity = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "activity" },
            react_1.default.createElement("path", { id: "Icon", d: "M22 13C22.5523 13 23 12.5523 23 12C23 11.4477 22.5523 11 22 11V13ZM18 12V11C17.5696 11 17.1874 11.2754 17.0513 11.6838L18 12ZM15 21L14.0513 21.3162C14.1874 21.7246 14.5696 22 15 22C15.4304 22 15.8126 21.7246 15.9487 21.3162L15 21ZM9 3L9.94868 2.68377C9.81257 2.27543 9.43043 2 9 2C8.56957 2 8.18743 2.27543 8.05132 2.68377L9 3ZM6 12V13C6.43043 13 6.81257 12.7246 6.94868 12.3162L6 12ZM2 11C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13V11ZM22 11H18V13H22V11ZM17.0513 11.6838L14.0513 20.6838L15.9487 21.3162L18.9487 12.3162L17.0513 11.6838ZM15.9487 20.6838L9.94868 2.68377L8.05132 3.31623L14.0513 21.3162L15.9487 20.6838ZM8.05132 2.68377L5.05132 11.6838L6.94868 12.3162L9.94868 3.31623L8.05132 2.68377ZM6 11H2V13H6V11Z" }))));
};
exports.default = Activity;
